import React, { ReactElement, useCallback } from 'react';
import { Box, FormLabel } from '@mui/material';
import { FormattedMessage } from 'intl';
import { AnalyticsTranslationKeys } from 'intl/keys';
import { validateSegment } from 'charts/disabled/resolutionTime';
import { segmentsContainerSx, segmentsSectionHeaderSx } from './styles';
import { SingleSegment } from './SingleSegment';
import type { SegmentsControlProps } from './types';

export function SegmentsControl({
  localValue,
  localSetter,
  disabled,
}: SegmentsControlProps): ReactElement {
  const handleSegmentChange = useCallback(
    (
      index: number,
      value: number | undefined,
      type: 'rangeMin' | 'rangeMax'
    ): void => {
      const newValue = [...localValue];
      newValue[index][type] = value;
      localSetter(newValue);
    },
    [localValue, localSetter]
  );

  return (
    <>
      <FormLabel sx={segmentsSectionHeaderSx}>
        <FormattedMessage id={AnalyticsTranslationKeys.segmentsDays} />
      </FormLabel>
      <Box sx={segmentsContainerSx}>
        {localValue.map((segment, index) => {
          const { rangeMin, rangeMax, color } = segment;

          return (
            <SingleSegment
              key={index}
              color={color}
              rangeMin={rangeMin}
              rangeMax={rangeMax}
              index={index}
              disabled={disabled}
              error={validateSegment(segment)}
              onChange={handleSegmentChange}
            />
          );
        })}
      </Box>
    </>
  );
}
